import { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { IoLogoPaypal } from "react-icons/io5";
import logo from "../../assets/IconMetuaa.png";
import profileAvatar from "../../assets/images/avatar.png";
import { apiUrl } from "../../Constants";
import WalletApi from "../../Services/Wallet";
import "../../Pages/DashboardClient/HomePage.css";
import "../PaypalApproved/HomePage.css";
import "./HomePage.css";

const headerLinks = [
  { label: "Covoiturage", href: "/" },
  { label: "Bus", href: "/" },
  { label: "Train", href: "/" },
  { label: "Livraison", href: "/" },
  { label: "Courses", href: "/" },
  { label: "Offres", href: "/", badge: "Nouveau" },
];

function formatFCFA(amount) {
  const num = Number(amount) || 0;
  return num.toLocaleString("fr-FR").replace(/\u202f/g, " ");
}

function formatDateTime(value) {
  const date = value ? new Date(value) : new Date();

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

function LogoMark() {
  return <img src={logo} alt="Logo METUA'A" className="dbc-logo-image" />;
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 4a5 5 0 0 0-5 5v2.5c0 .9-.3 2.1-.8 3l-.9 1.5h13.4l-.9-1.5c-.5-.9-.8-2.1-.8-3V9a5 5 0 0 0-5-5Z" />
      <path d="M9.5 19a2.5 2.5 0 0 0 5 0" />
    </svg>
  );
}

function ChevronDownIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 6l12 12M18 6 6 18" />
    </svg>
  );
}

function InfoIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 10.2v5.2" />
      <circle cx="12" cy="7.8" r="1" />
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3l7 4v5c0 4.5-3 7.7-7 9-4-1.3-7-4.5-7-9V7l7-4Z" />
      <path d="M9.2 12.1l1.8 1.8 3.8-3.8" />
    </svg>
  );
}

function PaypalBadge() {
  return <IoLogoPaypal aria-hidden="true" focusable="false" />;
}

function TopHeader() {
  const authUser = useSelector((state) => state?.AuthReducer?.user || {});

  const resolvedUser = {
    firstName: authUser?.firstName || authUser?.first_name || "",
    lastName: authUser?.lastName || authUser?.last_name || "",
    email: authUser?.email || "",
    phone: authUser?.phone || "",
    image_local: authUser?.image_local || "",
    avatar: authUser?.avatar_url || "",
  };

  const displayName = authUser?.name || `${resolvedUser.firstName} ${resolvedUser.lastName}`.trim() || "Utilisateur";
  const displaySubtitle = resolvedUser.email || resolvedUser.phone || "Voir le profil";

  return (
    <header className="dbc-nav-shell">
      <div className="dbc-container dbc-nav-container">
        <div className="dbc-nav">
          <Link to="/" className="dbc-logo" aria-label="METUA'A">
            <LogoMark />
            <span>METUA&apos;A</span>
          </Link>

          <nav className="dbc-main-links" aria-label="Navigation principale">
            {headerLinks.map((item) => (
              <Link key={item.label} to={item.href} className="dbc-main-link">
                <span>{item.label}</span>
                {item.badge ? <span className="dbc-main-badge">{item.badge}</span> : null}
              </Link>
            ))}
          </nav>

          <div className="dbc-right">
            <span className="dbc-flag" aria-label="France">
              <i />
              <i />
              <i />
            </span>

            <button type="button" className="dbc-notification-btn" aria-label="Notifications">
              <BellIcon />
              <span className="dbc-notification-badge">3</span>
            </button>

            <div className="dbc-profile-btn" aria-label="Profil utilisateur">
              <span className="dbc-profile-avatar" aria-hidden="true">
                <img
                  src={resolvedUser.image_local ? `${apiUrl}${resolvedUser.image_local}` : resolvedUser.avatar || profileAvatar}
                  alt=""
                  aria-hidden="true"
                />
              </span>
              <span className="dbc-profile-copy">
                <strong>{displayName}</strong>
                <small>{displaySubtitle}</small>
              </span>
              <ChevronDownIcon />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

function CancelMark() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 7l10 10M17 7 7 17" />
    </svg>
  );
}

function HelpIllustration() {
  return (
    <div className="payment-cancel-help-illustration" aria-hidden="true">
      <span className="payment-cancel-help-box" />
      <span className="payment-cancel-help-badge">x</span>
      <span className="payment-cancel-help-shadow" />
    </div>
  );
}

export default function PaiementCancel() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const captureKeyRef = useRef("");

  const resolvedToken = String(
    useSelector((state) => state?.AuthReducer?.lewooPayToken || localStorage.getItem("lewooPayToken") || "")
  ).trim();

  const orderId = searchParams.get("token") || searchParams.get("orderId") || searchParams.get("paypal_order_id") || "";
  const queryAmount = Number(searchParams.get("amount")) || 25000;
  const queryCurrency = searchParams.get("currency") || "FCFA";
  const queryDate = searchParams.get("date") || searchParams.get("created_at") || "";
  const fromWallet = searchParams.get("from") || "wallet-client";
  const VALID_WALLETS = ["wallet-client", "wallet-driver", "wallet-entreprise"];
  const walletRoute = VALID_WALLETS.includes(fromWallet) ? `/${fromWallet}` : "/wallet-client";

  useEffect(() => {
    if (!orderId || !resolvedToken) return undefined;

    const captureKey = `${orderId}:${resolvedToken}`;
    if (captureKeyRef.current === captureKey) return undefined;

    captureKeyRef.current = captureKey;
    let isMounted = true;

    WalletApi.capturePaypalOrder(resolvedToken, orderId).catch(() => {
      if (!isMounted) return;
    });

    return () => {
      isMounted = false;
    };
  }, [orderId, resolvedToken]);

  const paymentData = {
    amount: queryAmount,
    currency: queryCurrency,
    paypal_order_id: orderId || "3EF56042UM779370V",
    status: "Annulé",
    created_at: queryDate || new Date().toISOString(),
  };

  const displayAmount = formatFCFA(paymentData.amount);
  const displayCurrency = paymentData.currency || "FCFA";
  const displayReference = paymentData.paypal_order_id || orderId || "3EF56042UM779370V";
  const displayDateTime = formatDateTime(paymentData.created_at);

  return (
    <div className="dbc-page paypal-approved-page payment-cancel-page">
      <TopHeader />

      <main className="paypal-approved-main">
        <div className="paypal-approved-shell">
          <section className="paypal-approved-hero" aria-label="Paiement annulé">
            <div className="paypal-approved-mark" aria-hidden="true">
              <span className="paypal-approved-mark-ring" />
              <span className="paypal-approved-mark-core">
                <CancelMark />
              </span>
              <span className="paypal-approved-dot paypal-approved-dot-1" />
              <span className="paypal-approved-dot paypal-approved-dot-2" />
              <span className="paypal-approved-dot paypal-approved-dot-3" />
              <span className="paypal-approved-dot paypal-approved-dot-4" />
            </div>

            <h1>Paiement annulé</h1>
            <p>
              Vous avez interrompu le paiement.
              <br />
              Aucun montant n&apos;a été débité, votre solde reste inchangé.
            </p>
          </section>

          <section className="paypal-approved-details" aria-label="Détails du paiement annulé">
            <div className="paypal-approved-row">
              <span>Montant</span>
              <strong className="paypal-approved-amount">
                {displayAmount} {displayCurrency}
              </strong>
            </div>

            <div className="paypal-approved-row">
              <span>Moyen de paiement</span>
              <strong className="paypal-approved-method">
                <span className="paypal-approved-method-icon">
                  <PaypalBadge />
                </span>
                PayPal (Sandbox)
              </strong>
            </div>

            <div className="paypal-approved-row">
              <span>Référence PayPal</span>
              <strong>{displayReference}</strong>
            </div>

            <div className="paypal-approved-row">
              <span>Statut</span>
              <strong className="paypal-approved-status">
                <span />
                {paymentData.status}
              </strong>
            </div>

            <div className="paypal-approved-row">
              <span>Date et heure</span>
              <strong>{displayDateTime}</strong>
            </div>
          </section>

          <section className="paypal-approved-callout payment-cancel-callout" aria-label="Aucun débit effectué">
            <div className="paypal-approved-callout-icon" aria-hidden="true">
              <InfoIcon />
            </div>
            <div>
              <strong>Aucun débit effectué</strong>
              <p>Votre paiement est annulé. Vous pouvez réessayer à tout moment.</p>
            </div>
          </section>

          <div className="paypal-approved-manual">
            <p>L&apos;application ne s&apos;est pas ouverte automatiquement ?</p>
            <Link to={walletRoute} className="paypal-approved-manual-link">
              Ouvrir l&apos;application manuellement
            </Link>
          </div>

          <section className="paypal-approved-update-card payment-cancel-help-card" aria-label="Aide">
            <HelpIllustration />
            <div className="paypal-approved-update-copy">
              <strong>Besoin d&apos;aide ?</strong>
              <p>
                Si le problème persiste ou si vous souhaitez réessayer, vous pouvez retourner sur Metua&apos;a et
                relancer le paiement.
              </p>
              <Link to={walletRoute} className="payment-cancel-help-button">
                Retourner sur Metua&apos;a
              </Link>
            </div>
          </section>

          <footer className="paypal-approved-footer">
            <div className="paypal-approved-footer-pill">
              <ShieldIcon />
              <span>Paiement sécurisé par PayPal (Sandbox)</span>
            </div>
            <p>Vos transactions sont sécurisées et chiffrées.</p>
          </footer>
        </div>
      </main>
    </div>
  );
}
